import { $logout, $setFcmToken } from '@/api/auth/auth';
import { getFirebaseToken } from '@/plugins/firebasenotify';
import { Component, Mixins } from 'vue-property-decorator';
import profileMethods from "@/models/modules/profile";
import { profileEntity } from "@/models/modules/profile/entity";
import { $getCustomerCompany } from '@/api/mainPage/company/company';
import { IUpdateCompanyData, IUpdateCompanyMfo, IUpdateCompanyUlName } from '@/api/mainPage/company/interface';
import { IProfileEntity } from '@/models/modules/profile/interface';
import Redirect from '@/mixins/redirect/redirect';
import auth from "@/models/modules/auth";
import { DigitalSignCrmId, VerifyOtpForDigitalSign } from '../types/auth-via-digital-sign';
import { IAuthData } from '@/api/auth/interface';
import { $verifyOtpForAuthViaDigitalSign } from '../api';
import { VerifySmsData } from '@/api/sms/types';
import { VerifyOtpForDigitalSignResult } from '../types/auth-via-digital-sign';
import NotificationCore from '@/modules/NotificationCore/NotificationCore';
import { EventEmitterName } from '@/modules/Event/interface';
import EventEmitter from '@/modules/Event/EventEmitter';
import { PaymentRequirementsIncomingStore } from '@/feature/PaymentRequirements/store/incoming';
import { PaymentRequirementsIncomingMutation } from '@/feature/PaymentRequirements/store/incoming/constants';
import FraudHandler from '@/modules/security/fraud-handler';
import { authEntity } from '@/models/modules/auth/entity';

@Component
export default class AuthConfirmViaOtp extends Mixins(
	Redirect
) {

	@PaymentRequirementsIncomingStore.Mutation(
		PaymentRequirementsIncomingMutation.setUnprocessedListShowed
	)
	setPaymentRequirementsListShowed(_payload: boolean) {}

	digitalSignCrmId: DigitalSignCrmId = {
		flCrmId: 0,
		ulCrmId: 0
	}

	smsCode: string = ''

	loginTries: number = 0

	smsCodeCancellationDialog: boolean = false

	forgotPasswordDialog: boolean = false

	maxLoginTries: number = 4

	smsDialogIsActive: boolean = false

	otpVerifyId: number = 0

	otpRemainingTime: number = 90

	verifySmsRequest = (data: VerifySmsData) => this.verifySms(data)

	cancelSmsCodeCancellationDialog() {
		this.smsCodeCancellationDialog = false;
	}

	confirmSmsCodeCancellationDialog() {
		this.smsDialogIsActive = this.smsCodeCancellationDialog = false;
	}

	openSmsCodeCancellationDialog() {
		if (this.smsDialogIsActive)
			this.smsCodeCancellationDialog = true;
	}

	getAuthViaOtpData(): VerifyOtpForDigitalSign {
		return {
			...this.digitalSignCrmId,
			smsCode: this.smsCode,
			verifyId: this.otpVerifyId,
		};
	}

	async authViaOtp(): Promise<VerifyOtpForDigitalSignResult | null> {
		return $verifyOtpForAuthViaDigitalSign(this.getAuthViaOtpData());
	}

	async verifySms(data: VerifySmsData): Promise<boolean> {
		this.loginTries += 1;
		this.smsCode = data.smsCode;

		const authResult = await this.authViaOtp();

		if (authResult) {
			auth.signIn(authResult as IAuthData);
			this.onSignedIn();
		}

		return !!authResult;
	}

	async signInAndLoadCompany(value: IAuthData) {
		auth.signIn(value);

		return this.onSignedIn();
	}

	async onSignedIn() {
		await this.loadCompany();
		FraudHandler.onLogin(profileEntity);
	}

	async loadCompany() {
		return $getCustomerCompany({ transliteration: "true" })
			.then((profile: IUpdateCompanyData) => {
				if (!profile) return $logout();

				profileMethods.setProfile(this.getProfileDataForStore(profile));

				profileEntity.company = profile;

				if (this.$route.name !== 'Login') {
					EventEmitter.emit(EventEmitterName.COMPANY_CHANGE);
				} else {
					this.setPaymentRequirementsListShowed(false);
					NotificationCore.clear();
					this.redirectTo("Home");
					this.sendFcmToken();
				}
			});
	}

	getProfileDataForStore(profile: IUpdateCompanyData): IProfileEntity | undefined {
		const defaultProfile: IUpdateCompanyUlName | undefined = profile
			.employeeInfo
			.find(v => v.branches.find(i => i.isCurrent));

		if (!defaultProfile) return;

		const defaultBranch: IUpdateCompanyMfo | undefined = defaultProfile
			.branches
			.find(v => v.isCurrent);

		if (!defaultBranch) return;

		return {
			flCrmId: profile.flCrmId,
			ulCrmId: defaultProfile.ulCrmId,
			ulName: defaultProfile.ulName,
			role: defaultProfile.role,
			mfoUl: defaultBranch.mfoUl,
			nciId: defaultBranch.nciId,
			ulCity: defaultProfile.ulCity,
			ulAddress: defaultProfile.ulAddress,
			ulInn: defaultProfile.ulInn,
			ulPinfl: defaultProfile.ulPinfl,
			customerType: profile.customerType
		};
	}

	async sendFcmToken(): Promise<any> {
		return getFirebaseToken().then(async firebaseToken =>
			firebaseToken && $setFcmToken(firebaseToken));
	}

}